import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const V2_API_CALLBACK =
  process.env.REACT_APP_V2_API_CALLBACK ||
  'https://api-v2.offstore.me/payment-gateways/PAGBANK/oauth-callback';

function isV2State(state) {
  return state && state.length === 33 && /^2[a-f0-9]{32}$/.test(state);
}

export default function RedirectURIPagBank() {
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');

  useEffect(() => {
    if (code && state && isV2State(state)) {
      window.location.href = `${V2_API_CALLBACK}?code=${encodeURIComponent(
        code
      )}&state=${encodeURIComponent(state)}`;
      return;
    }

    if (code) {
      history.push(`/paymentmethods/configurationpagbank?codepb=${code}`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, state]);

  return <></>;
}
